// /src/DesktopNotificationManager.js

// English comments only in code blocks
import LogoNotification from "./medias/Logo_Notification.png";

let deliveredSet = new Set();

// English comment: load delivered ids from storage
export function loadDeliveredRegistry() {
  try {
    const raw = localStorage.getItem("deliveredNotifications");
    if (raw) deliveredSet = new Set(JSON.parse(raw));
  } catch (_) {}
}

// English comment: persist delivered ids
function persist() {
  localStorage.setItem(
    "deliveredNotifications",
    JSON.stringify([...deliveredSet])
  );
}

// English comment: ask browser permission
export async function ensurePermission() {
  if (!("Notification" in window)) return false;

  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;

  const res = await Notification.requestPermission();
  return res === "granted";
}

// English comment: push desktop notification if not already done
export async function pushDesktopNotification(n) {
  const allowed = await ensurePermission();
  if (!allowed) return;

  if (deliveredSet.has(n.id)) return;

  new Notification(n.payload?.title ?? "Notification", {
    body: n.payload?.message ?? "",
    icon: LogoNotification,            // English comment: custom icon (192×192 PNG)
  });

  deliveredSet.add(n.id);
  persist();
}

// English comment: check if already delivered
export function isDelivered(id) {
  return deliveredSet.has(id);
}
